import { EnumColor } from '@40seas/frontend/common/providers';
import { PlaidAccessTokenStatus } from '@40seas/entities/plaid';

export const PlaidAccessTokenDecisionColorMapping = {
    [PlaidAccessTokenStatus.Active]: 'success',
    [PlaidAccessTokenStatus.Disconnected]: 'error',
    [PlaidAccessTokenStatus.Inactive]: 'error',
} as { [key in PlaidAccessTokenStatus]: EnumColor };
